import React from 'react';
import { Header } from './components';


const Mista2015 = () => {
  window.scrollTo(0, 0)
  return (
    <Header />
  );
};


export default Mista2015;